import { createStore, applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import thunkMiddleware from 'redux-thunk';
import rootReducer from '../reducers';

const middleware = [thunkMiddleware];
if (process.env.NODE_ENV !== 'production') {
  middleware.push(createLogger());
}

const createStoreWithMiddleware = createStore(
  rootReducer,
  applyMiddleware(...middleware),
);

export default function configureStore() {
  return createStoreWithMiddleware;
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js